import React, { useEffect, useState, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import InputText from './inputs/InputText';
import InputSelect from './inputs/InputSelect';
import styled from 'styled-components';

import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Button
} from '@material-ui/core';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../consts';
import { debounce, get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { FormSeparator } from '../pages/ativiadade/styled/ItemStyles';
import { TrackGoogleAnalyticsEvent } from '../utils/googleAnalytics';
import {
  ClickAllTrilhasAction,
  ClickAllTrilhas
} from '../utils/googleAnalytics/events/TrilhasAdaptativas/EventAllTrilhas';

const FilterAtividades = ({
  open,
  handleClose,
  search,
  onChange,
  filters,
  filtersOnChange,
  cleanState
}) => {
  const [firstTimeOpening, setFirstTimeOpening] = useState(true);
  const [optionsInput, setOptionsInput] = useState({
    curso: [],
    periodo: [],
    habilidades: [],
    matriz_referencia: [],
    componente_curricular: [],
    area_conhecimento: []
  });
  const [optionsSelect, setOptionsSelect] = useState({
    area_conhecimento: '',
    curso: '',
    codigoAvaliacao: '',
    componente_curricular: '',
    habilidade: '',
    id: '',
    periodo: '',
    matriz_referencia: '',
    tipo_avaliacao: '',
  });
  const [habilidade, setHabilidade] = useState('');
  const [titulo, setTitulo] = useState('');
  const [categoria, setCategoria] = useState('');

  const TipoHardCode = [
    {label:'PAE', value:1},
    {label:'Oficial SESI', value:2},
    {label:'Processual', value:3}
  ]

  useEffect(() => {
    const ultimoCaractere = window.location.pathname.slice(-1);

    switch (ultimoCaractere) {
      case '1':
        setCategoria('trilhas');
        setTitulo('Buscar Trilhas Adaptativas');
        break;
      case '2':
        setTitulo('Buscar Avaliações');
        setCategoria('avaliacoes');
        break;
      case '3':
        setTitulo('Buscar Atividades Processuais');
        setCategoria('atividades');
        break;
      default:
        setTitulo('Buscar Trilhas Adaptativas');
        setCategoria('trilhas');
        break;
    }
  }, [window.location.pathname]);

  const theme = useContext(ThemeContext);

  useEffect(() => {
    if (firstTimeOpening) {
      fetchCurso();
      fetchPeriodo();
      fetchAreasConhecimento();
      fetchExames();
      fetchMatrizReferencia();
      fetchComponenteCurricular();
      setFirstTimeOpening(false);
    }
    fetchHabilidade();
  }, []);

  useEffect(() => {
    fetchHabilidade();
  }, [habilidade]);

  useEffect(() => {
    if (filters) {
      var changePageFilter = {};
      for (var prop in filters) {
        changePageFilter[prop] = filters[prop];
      }

      setOptionsSelect(changePageFilter);
      fetchPeriodo();
    }
  }, [open]);

  useEffect(() => {
    if (cleanState) {
      setOptionsSelect({
        area_conhecimento: '',
        curso: '',
        codigoAvaliacao: '',
        componente_curricular: '',
        habilidade: '',
        id: '',
        periodo: '',
        matriz_referencia: ''
      });
    }
  }, [cleanState]);

  const analytcsClick = (name, type) => {
    let label = 'Click' + ': ' + name;
    let category = ClickAllTrilhas + '_' + type;

    TrackGoogleAnalyticsEvent(category, ClickAllTrilhasAction, label);
  };

  const fetchCurso = () => {
    const params = { type: categoria };

    axios
      .get(`${API_HOST}/core/curso/options_filters`, { params })
      .then((response) => {
        const options = [];
        response.data.forEach((mapResponse) => {
          if (mapResponse.oculto !== true) {
            options.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.codigo
            });
          }
        });

        setOptionsInput((prevState) => ({ ...prevState, curso: options }));
      })
      .catch((error) => console.error(error));
  };

  const fetchPeriodo = (e) => {
    if (filters.curso || filtersOnChange.curso) {
      const params = {
        type: categoria,
        nivel_id: e || ''
      };
      axios
        .get(`${API_HOST}/core/periodo/options_filters`, { params })
        .then((response) => {
          const options = [];
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao
              });
            }
          });

          setOptionsInput((prevState) => ({ ...prevState, periodo: options }));
        })
        .catch((error) => console.error(error));
    } else {
      const params = {
        type: categoria
      };
      axios
        .get(`${API_HOST}/core/periodo/options_filters`, { params })
        .then((response) => {
          const options = [];
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao
              });
            }
          });

          setOptionsInput((prevState) => ({ ...prevState, periodo: options }));
        })
        .catch((error) => console.error(error));
    }
  };

  const fetchAreasConhecimento = () => {
    const params = { type: categoria };
    axios
      .get(`${API_HOST}/core/area_conhecimento/options_filters`, { params })
      .then((response) => {
        setOptionsInput((prevState) => ({
          ...prevState,
          area_conhecimento: response.data.map((item) => ({
            value: item.id,
            label: item.descricao
          }))
        }));
      });
  };

  const fetchExames = () => {
    const params = { type: categoria };
    axios
      .get(`${API_HOST}/core/exame/options_filters`, { params })
      .then((response) => {
        setOptionsInput((prevState) => ({
          ...prevState,
          exame: response.data.map((item) => ({
            value: item.id,
            label: item.descricao
          }))
        }));
      });
  };

  const fetchMatrizReferencia = (cursoId, etapaId) => {
    const params = {
      curso__id: cursoId || (optionsSelect.curso && optionsSelect.curso.codigo),
      areas_conhecimento__id:
        filters.area_conhecimento || filtersOnChange.area_conhecimento,
      etapa_id: etapaId,
      type: categoria
    };
    axios
      .get(`${API_HOST}/matriz_referencia/matriz_referencia/options_filters`, {
        params
      })
      .then((response) => {
        const options = response.data.map((x) => ({
          value: x.id,
          label: x.descricao
        }));

        setOptionsInput((prevState) => ({
          ...prevState,
          matriz_referencia: options
        }));
      })
      .catch((error) => console.error(error));
  };

  const fetchComponenteCurricular = (e) => {
    const params = {
      type: categoria,
      area_conhecimento_id:
        e ||
        filters.area_conhecimento ||
        filtersOnChange.area_conhecimento ||
        optionsSelect.area_conhecimento.value
    };

    axios
      .get(`${API_HOST}/core/componente_curricular`, { params })
      .then((response) => {
        const options = response.data.map((mapResponse) => ({
          value: mapResponse.id,
          label: mapResponse.descricao
        }));
        setOptionsInput((prevState) => ({
          ...prevState,
          componente_curricular: options
        }));
      });
  };

  const handleOnChange = debounce((e) => {
    setHabilidade(e);
  }, 1000);

  const fetchHabilidade = () => {
    const params = {
      type: categoria,
      area_conhecimento_id:
        filters.area_conhecimento || filtersOnChange.area_conhecimento,
      matriz_id: filters.matriz_referencia || filtersOnChange.matriz_referencia,
      etapa_id: filters.periodo || filtersOnChange.periodo,
      disciplina:
        filters.componente_curricular || filtersOnChange.componente_curricular,
      search: habilidade
    };

    axios
      .get(`${API_HOST}/matriz_referencia/habilidade/options_filters`, {
        params
      })
      .then((response) => {
        const options =
          response.data &&
          response.data.map((mapResponse) => ({
            value: mapResponse.id,
            label: `${mapResponse.cd_habilidade} - ${mapResponse.ds_habilidade}`
          }));

        setOptionsInput((prevState) => ({
          ...prevState,
          habilidades: options
        }));
      });
  };

  const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeButton: {
      right: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  });

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography
          variant="h6"
          style={{
            color: '#333',
            fontFamily: 'Public Sans',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: 'normal',
            marginLeft: '5px'
          }}
        >
          {children}
        </Typography>
      </MuiDialogTitle>
    );
  });

  const renderForm = () => {
    return (
      <Form>
        <Grid item container xs={12}>
          <Grid item container xs={12}>
            <Grid
              item
              container
              xs={12}
              style={{ marginTop: '1rem', display: 'flex' }}
            >
              <Grid item xs={6}>
                <InputSelect
                  label="Segmento/Etapa"
                  field="curso"
                  value={
                    get(filters, 'curso') === get(optionsSelect, 'curso.value')
                      ? get(filters, 'curso')
                      : get(filtersOnChange, 'curso') ===
                        get(optionsSelect, 'curso.value')
                      ? get(filtersOnChange, 'curso')
                      : get(optionsSelect, 'curso')
                  }
                  onChange={(e) => {
                    const label = get(e, 'label', 'Excluído');
                    analytcsClick(
                      `Filtro Segmento/Etapa: ${label}`,
                      'Filter All Trilhas'
                    );
                    onChange(e, 'curso');
                    let value = e && e.value;
                    if (
                      value === 6 ||
                      (value === 10 &&
                        get(optionsSelect, 'componente_curricular'))
                    ) {
                      setOptionsSelect((prevState) => ({
                        ...prevState,
                        curso: e,
                        componente_curricular: '',
                        periodo: '',
                        matriz_referencia: '',
                        habilidade: ''
                      }));
                    } else {
                      setOptionsSelect((prevState) => ({
                        ...prevState,
                        curso: e,
                        periodo: '',
                        matriz_referencia: '',
                        habilidade: ''
                      }));
                    }
                    fetchHabilidade();
                    fetchMatrizReferencia(get(e, 'codigo') || '', null);
                    fetchPeriodo(get(e, 'codigo') || '');
                  }}
                  options={optionsInput.curso}
                />
              </Grid>
              <Grid item xs={6}>
                <InputSelect
                  label="Série/Ano"
                  field="periodo"
                  value={
                    get(filters, 'periodo') ===
                    get(optionsSelect, 'periodo.value')
                      ? get(filters, 'periodo')
                      : get(filtersOnChange, 'periodo') ===
                        get(optionsSelect, 'periodo.value')
                      ? get(filtersOnChange, 'periodo')
                      : get(optionsSelect, 'periodo')
                  }
                  onChange={(e) => {
                    const label = get(e, 'label', 'Excluído');
                    analytcsClick(
                      `Filtro Série/Ano: ${label}`,
                      'Filter All Trilhas'
                    );
                    onChange(e, 'periodo');

                    setOptionsSelect((prevState) => ({
                      ...prevState,
                      periodo: e,
                      habilidade: '',
                      matriz_referencia: ''
                    }));

                    fetchMatrizReferencia(null, get(e, 'value'));
                    fetchHabilidade();
                  }}
                  options={optionsInput.periodo}
                />
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={12}
              style={{ marginTop: '1rem', display: 'flex' }}
            >
              <Grid item xs={6}>
                <InputSelect
                  label="Área do conhecimento"
                  field="area_conhecimento"
                  value={
                    get(filters, 'area_conhecimento') ===
                    get(optionsSelect, 'area_conhecimento.value')
                      ? get(filters, 'area_conhecimento')
                      : get(filtersOnChange, 'area_conhecimento') ===
                        get(optionsSelect, 'area_conhecimento.value')
                      ? get(filtersOnChange, 'area_conhecimento')
                      : get(optionsSelect, 'area_conhecimento')
                  }
                  onChange={(e) => {
                    const label = get(e, 'label', 'Excluído');
                    analytcsClick(
                      `Filtro Área do conhecimento: ${label}`,
                      'Filter All Trilhas'
                    );
                    onChange(e, 'area_conhecimento');
                    let value = e && e.value;
                    setOptionsSelect((prevState) => ({
                      ...prevState,
                      area_conhecimento: e,
                      componente_curricular: '',
                      matriz_referencia: '',
                      habilidade: ''
                    }));

                    fetchComponenteCurricular(value);
                    fetchHabilidade();
                  }}
                  options={optionsInput.area_conhecimento}
                />
              </Grid>

              {get(optionsSelect, 'curso.value', get(optionsSelect, 'curso')) ==
                6 ||
              get(optionsSelect, 'curso.value', get(optionsSelect, 'curso')) ==
                10 ? (
                <></>
              ) : (
                <Grid item xs={6}>
                  <InputSelect
                    autoload
                    label="Componente curricular"
                    field="componente_curricular"
                    options={optionsInput.componente_curricular}
                    value={
                      get(filters, 'componente_curricular') ===
                      get(optionsSelect, 'componente_curricular.value')
                        ? get(filters, 'componente_curricular')
                        : get(filtersOnChange, 'componente_curricular') ===
                          get(optionsSelect, 'componente_curricular.value')
                        ? get(filtersOnChange, 'componente_curricular')
                        : get(optionsSelect, 'componente_curricular')
                    }
                    onChange={(e) => {
                      const label = get(e, 'label', 'Excluído');
                      analytcsClick(
                        `Filtro Componente curricular: ${label}`,
                        'Filter All Trilhas'
                      );
                      onChange(e, 'componente_curricular');
                      setOptionsSelect((prevState) => ({
                        ...prevState,
                        componente_curricular: e,
                        habilidade: ''
                      }));
                      fetchHabilidade();
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <FormSeparator>
                <Typography
                  style={{
                    marginTop: '20px',
                    color: '#333',
                    fontFamily: 'Public Sans',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal'
                  }}
                >
                  Habilidades
                </Typography>
              </FormSeparator>
            </Grid>
            <Grid
              item
              container
              xs={12}
              style={{ marginTop: '1rem', display: 'flex' }}
            >
              <Grid item xs={6}>
                <InputSelect
                  autoload
                  label="Matriz de referência"
                  field="matriz_referencia"
                  options={optionsInput.matriz_referencia}
                  value={
                    get(filters, 'matriz_referencia') ===
                    get(optionsSelect, 'matriz_referencia.value')
                      ? get(filters, 'matriz_referencia')
                      : get(filtersOnChange, 'matriz_referencia') ===
                        get(optionsSelect, 'matriz_referencia.value')
                      ? get(filtersOnChange, 'matriz_referencia')
                      : get(optionsSelect, 'matriz_referencia')
                  }
                  onChange={(e) => {
                    const label = get(e, 'label', 'Excluído');
                    analytcsClick(
                      `Filtro Matriz de referência: ${label}`,
                      'Filter All Trilhas'
                    );
                    onChange(e, 'matriz_referencia');
                    setOptionsSelect((prevState) => ({
                      ...prevState,
                      matriz_referencia: e,
                      habilidade: ''
                    }));
                    fetchHabilidade();
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <InputSelect
                  autoload
                  label="Habilidade"
                  field="habilidade"
                  options={optionsInput.habilidades}
                  value={
                    get(filters, 'habilidades') ===
                    get(optionsSelect, 'habilidade.value')
                      ? get(filters, 'habilidades')
                      : get(filtersOnChange, 'habilidades') ===
                        get(optionsSelect, 'habilidade.value')
                      ? get(filtersOnChange, 'habilidades')
                      : get(optionsSelect, 'habilidade.value')
                      ? get(optionsSelect, 'habilidade.value')
                      : get(optionsSelect, 'habilidade')
                  }
                  onChange={(e) => {
                    const label = get(e, 'label', 'Excluído');
                    analytcsClick(
                      `Filtro Habilidade: ${label}`,
                      'Filter All Trilhas'
                    );
                    onChange(e, 'habilidade');
                    setOptionsSelect((prevState) => ({
                      ...prevState,
                      habilidade: e
                    }));
                  }}
                  onInputChange={(event) => {
                    if (event) {
                      handleOnChange(event);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <FormSeparator>
                <Typography
                  style={{
                    marginTop: '20px',
                    color: '#333',
                    fontFamily: 'Public Sans',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal'
                  }}
                >
                  Classificação
                </Typography>
              </FormSeparator>
            </Grid>
            <Grid
              item
              container
              xs={12}
              style={{ marginTop: '1rem', display: 'flex' }}
            >
              <Grid item xs={6}>
                <InputText
                  label="Código da Avaliação"
                  field="id"
                  value={
                    get(filters, 'id') === get(optionsSelect, 'id')
                      ? get(filters, 'id')
                      : get(filtersOnChange, 'id') === get(optionsSelect, 'id')
                      ? get(filtersOnChange, 'id')
                      : get(optionsSelect, 'id')
                  }
                  onBlur={(e) => {
                    const label =
                      e.target.value == '' ? 'Excluído' : e.target.value;
                    analytcsClick(
                      `Filtro Código da Avaliação: ${label}`,
                      'Filter All Trilhas'
                    );
                  }}
                  onChange={(e) => {
                    onChange(e, 'id');
                    setOptionsSelect((prevState) => ({
                      ...prevState,
                      id: e
                    }));
                  }}
                />
              </Grid>

              <Grid item xs={6} >
                <InputSelect
                  label="Tipo da avaliação"
                  field="tipo_avaliacao"
                  options={TipoHardCode}
                  onChange={(e) => {
                    onChange(e, 'tipo_avaliacao');
                    setOptionsSelect((prevState) => ({
                      ...prevState,
                      tipo_avaliacao: e 
                    }));
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    );
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth={false}
      aria-labelledby="responsive-dialog-title"
      onClosed={handleClose}
    >
      <DialogTitle>{titulo}</DialogTitle>

      <DialogContent dividers>
        <Grid container>
          <Grid item xs={12} md={12}>
            {renderForm()}
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions style={{ padding: '12px 30px 12px 0px' }}>
        <Button
          style={{
            width: '149px',
            padding: '9px 30px',
            gap: '15px',
            borderRadius: '70px',
            background: '#E4E4E4',
            boxShadow: '2px 2px 7px 0px rgba(0, 0, 0, 0.25)',
            textTransform: 'capitalize'
          }}
          onClick={() => {
            handleClose();
            setOptionsSelect({
              area_conhecimento: '',
              curso: '',
              codigoAvaliacao: '',
              componente_curricular: '',
              habilidade: '',
              id: '',
              periodo: '',
              matriz_referencia: ''
            });
          }}
        >
          <Typography
            style={{
              color: '#878787',
              fontFamily: 'Public Sans',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0em',
              textAlign: 'center'
            }}
          >
            Cancelar
          </Typography>
        </Button>
        <Button
          style={{
            width: '149px',
            padding: '9px 30px',
            gap: '15px',
            borderRadius: '70px',
            backgroundColor: theme.primary,
            boxShadow: '2px 2px 7px 0px rgba(0, 0, 0, 0.25)',
            textTransform: 'capitalize'
          }}
          onClick={search}
        >
          <Typography
            style={{
              color: '#FFFFFF',
              fontFamily: 'Public Sans',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0em',
              textAlign: 'center'
            }}
          >
            Buscar
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default styled(FilterAtividades)`
  .title-div {
    display: flex;
    width: 100%;
    height: 3rem;
    justify-content: space-between;
    padding: 0rem 1rem;
    align-items: center;
    background-color: ${(props) => props.theme.primary};
    border-radius: 5px 5px 0px 0px;
    label {
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0.5rem;
    }
    i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .subtitles {
    background: #f7f7f7;
    padding-top: 10px;
    padding-bottom: 7px;
    color: ${(props) => props.theme.primary};
    padding-left: 15px;
  }

  .input-divs {
    display: flex;
    padding: 1rem;
    width: 100%;
  }

  .buttons-div {
    width: 100%;
    display: flex;
    align-items: end;
    justify-content: end;
    gap: 1rem;
    padding: 1rem;
  }

  .button-search {
    background: ${(props) => props.theme.primary};
    color: #fff;
    :hover {
      background: ${(props) => props.theme.secondary};
    }
    :focus {
      outline: none;
    }
  }

  .button-close {
    background: ${(props) => props.theme.danger};
    color: #fff;
    :hover {
      background: ${(props) => props.theme.danger};
    }
    :focus {
      outline: none;
    }
  }
`;
